import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class OfficeService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'Office/';
  // fetch all Office in the database
  allOffice(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getOffice(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getOfficeByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postOffice(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteOffice(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateOffice(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
